import { takeLatest, put, call } from 'redux-saga/effects';
import {
    GET_CREDIT_LIMIT_MODEL_AT_SECTION_DATA,
    getCreditLimitModelResponse,
    getRecalculatecreditLimitAtSectionResponse,
    RECALCULATE_CREDIT_LIMIT_MODEL_AT_SECTION,
    SAVE_CREDIT_LIMIT_MODEL_AT_SECTION,
    getSavecreditLimitAtSectionResponse
} from './action';
import { CORE_API } from '../../../../../config';
import { HTTP_HEADERS } from '../../../../../constants'
import request from "../../../../../components/Utils/httpHelper";

export function* getCreditLimitModelDataRequest(action) {
    let requestURL = `${CORE_API}/creditlimit/generate/${action.data}`;
    try {
        const response = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(getCreditLimitModelResponse(response.data))
    }
    catch (err) {
        yield put(getCreditLimitModelResponse(err))
    }
}

export function* getCreditLimitModelAtSectionSaga() {
    yield takeLatest(GET_CREDIT_LIMIT_MODEL_AT_SECTION_DATA, getCreditLimitModelDataRequest);
}

export function* recalculatecreditLimitAtSection(action) {
    let requestURL = `${CORE_API}/creditlimit/recalculate`;
    try {
        const result = yield call(request, requestURL, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        //request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS }
        yield put(getRecalculatecreditLimitAtSectionResponse(result.data));
    } catch (err) {
        yield put(getRecalculatecreditLimitAtSectionResponse(err))
    }
}
export function* recalculatecreditLimitAtSectionSaga() {
    yield takeLatest(RECALCULATE_CREDIT_LIMIT_MODEL_AT_SECTION, recalculatecreditLimitAtSection);
}

export function* saveCreditLimitModelAtSection(action) {
    let requestURL = `${CORE_API}/creditlimit/save`;
    try {
        const result = yield call(request, requestURL, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        //request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS }
        yield put(getSavecreditLimitAtSectionResponse(result.data));
    } catch (err) {
        yield put(getSavecreditLimitAtSectionResponse(err))
    }
}
export function* saveCreditLimitModelAtSectionSaga() {
    yield takeLatest(SAVE_CREDIT_LIMIT_MODEL_AT_SECTION, saveCreditLimitModelAtSection);
}

